<template>
    <div>
        <el-row class="marB10">
            <el-col :span="10" :style="{height: tableHeight+100+'px',minWidth: '320px'}" class="bor">

                <div class=" flex marB10">
                    <el-input v-model="search" size="mini"></el-input>
                    <el-button class="marL5 " icon="el-icon-search" circle  @click="leftSearch" size="mini"></el-button>

                </div>
                <div class="con" :style="{height:tableHeight+'px',overflowY: 'auto'}">
                    <el-checkbox-group v-model="leftChoose"@change="handleLeftChange">
                            <el-checkbox v-for="item in tableData" :label="item" :key="item.i_obj" style="padding: 5px 0;display: block">
                                {{item.label}}
                            </el-checkbox>
                    </el-checkbox-group>
                </div>
                <el-pagination
                        class="fr page"
                        style="margin-top: 10px;text-align: right"
                        background
                        layout="prev, pager, next"
                        @current-change="pageCurrentChange"
                        :current-page.sync="pageSize"
                        :total="pageTotal"
                        :page-size="pageCount">
                </el-pagination>
            </el-col>
            <el-col :span="4"  style="height: 100%;">
                <div :style="{lineHeight:tableHeight+'px',textAlign:'center',overflowY: 'auto'}">
                    <el-button class="bcBtn" @click="addChoose" :class="baseerp+'btn'" size="mini" >添加</el-button>
                    <el-button class="bcBtn" @click="deleteChoose" :class="baseerp+'btn'" size="mini">删除</el-button>
                </div>
            </el-col>
            <el-col :span="10" class="bor"  :style="{height: tableHeight+100+'px',minWidth: '320px',overflowY: 'auto'}">
                <div class="con" >
                    <el-checkbox-group v-model="rightChoose"@change="handleRightChange">
                        <el-checkbox v-for="item in rightData" v-if="item.flag==0||item.flag==1" :label="item" :key="item.i_obj" style="padding: 5px 0;display: block">
                            {{item.label}}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </el-col>
        </el-row>
        <div class="pz" style="text-align: center">
            <el-button class="bcBtn" @click="saveBtn" :class="baseerp+'btn'" size="mini" >
                确定
            </el-button>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    // import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "TransferTable",
        props:{
            transferData:{
                type: Object,
                required:true,
            },
            transferChooseData:{
                type: Array,
                required:true,
            },
            customertype:{
                type:Number,
                required:true,

            }

        },
        components: {},
        data() {
            return {
                baseerp:'',
                tableData:[],
                rightData:[],
                tableHeight:0,
                pageCount:20,
                pageSize:1,
                pageTotal:0,
                search:'',
                choosesearch:'',
                tableKey:0,
                tableRightKey:0,
                leftChoose:[],
                rightChoose:[],
                leftCheck:false,
                rightCheck:false,
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            transferData:{
                handler() {
                    if(JSON.stringify(this.transferData)!='{}'){
                        // console.log(this.transferData,'water')
                        this.tableData=this.transferData.list
                        this.pageTotal=this.transferData.total
                        this.pid=this.transferData.pid
                        // console.log(this.tableData,'this.tableData')
// this.$forceUpdate()
                    }
                },
                immediate: true,
                deep:true,
            },
            transferChooseData:{
                handler() {
                    this.rightData =JSON.parse(JSON.stringify(this.transferChooseData))
                    this.rightData.map(o=>{
                        o.i_obj=o.vc_obj?o.vc_obj:o.i_obj
                    })
                },
                immediate: true,
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {

            this.baseerp=baseerp;
            // this.tableData=this.transferData.list
            // this.pageTotal=this.total
            this.$nextTick(()=>{

                this.onResize();

            })
        },
        methods: {

            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-200

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            addChoose(){
                if (this.leftChoose.length>=1){
                    this.leftChoose.forEach(val=>{
                        let at=this.rightData.findIndex(item=>item.i_obj==val.i_obj&&item.flag!=-1);
                        if (at==-1){
                            let obj=val;
                            obj.flag=0
                            obj.i_pid=this.pid
                            obj.i_obj=obj.i_obj
                            // obj.rightCheck=false
                            obj.i_type=this.customertype
                            this.rightData.unshift(obj)
                        }
                    })
                    this.leftChoose=[]
                    this.tableData.map(one=>{
                        this.$set(one,'leftCheck',false)
                        // one.leftCheck=false
                    });
                    this.rightChoose=[]
                    this.rightData.map(one=>{
                        one.rightCheck=false
                    })
                    // this.leftChoose=[];
                }
            },
            deleteChoose(){
                if (this.rightChoose.length>=1) {
                    this.rightData.map((val,index)=> {
                        let at=this.rightChoose.findIndex(item=>item.i_obj==val.i_obj);
                        if (at!==-1) {
                            val.flag = -1

                        }
                    })
                    this.rightData=this.rightData.filter(val =>!(val.flag==-1&&val.i_id==undefined));
                    this.rightChoose=[]
                    this.rightData.map(one=>{
                        one.rightCheck=false
                    })
                    // this.tableData.map(one=>{
                    //     one.leftCheck=false
                    // })
                    // this.leftChoose=[];

                    // this.rightCheck=false

                }
            },
            handleLeftChange(val){
                // console.log(this.ids    ,'isd')
                // if (val.leftCheck){
                //
                //     this.leftChoose.push(val)
                // }else{
                //     let i=this.leftChoose.findIndex(item=>item.i_obj==val.i_obj);
                //     this.leftChoose.splice(i,1)
                // }
                // console.log(this.leftChoose,'leftChoose')

                /* this.leftChoose=val
                 this.leftChoose=this.leftChoose.map(one=>{
                     one.i_flag=1
                     one.i_type=this.customertype
                 })*/
            },
            handleRightChange(val){
                // if (val.rightCheck){
                //     // let obj=val;
                //     // obj.flag=-1
                //     // obj.i_pid=this.pid
                //     // obj.i_obj=obj.i_obj
                //     // obj.rightCheck=true
                //     // obj.i_type=this.customertype
                //     this.rightChoose.push(val)
                // }else{
                //     let i=this.rightChoose.findIndex(item=>item.i_obj==val.i_obj);
                //     this.rightChoose.splice(i,1)
                // }
            },
            tableRowClassName(){},
            pageCurrentChange(val) {
                this.pageSize=val;
                this.$emit('getTransfer',val,this.search)
                // console.log(val,'val')
            },
            leftSearch(){
                //console.log(this.leftChoose,'lc')

                this.$emit('getTransfer',1,this.search)
            },
            /*rightSearch(){
                // this.$emit('getCAccCustomerList',this.choosesearch)
            },*/
            saveBtn(){
                    this.$emit('choosetran',this.rightData,this.customertype)
            },
            cancel(){
                this.$emit('close')
            },

        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .marL5{
        margin-left: 5px;
    }
    .marB10{
        margin-bottom: 10px;
    }
    .bor{
        border: 1px solid #ebeef5;
        padding: 8px 10px;
        border-radius: 5px;
    }
</style>